// Configuration centralisée de l'URL de l'API
// Production par défaut : https://api.piscineaquarius.com
// Pour tester en local, créez un fichier .env.local avec : VITE_API_URL=http://localhost:3000

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://api.piscineaquarius.com';

export const API_CONFIG = {
  baseUrl: API_BASE_URL,
  
  // Endpoints complets
  endpoints: {
    optimizeBookings: `${API_BASE_URL}/api/optimize/bookings`,
    clientRdv: `${API_BASE_URL}/api/client-rdv`,
    mapboxClientsNearby: `${API_BASE_URL}/api/mapbox/clients-nearby`,
    mapboxClientsNearbyCoordinates: `${API_BASE_URL}/api/mapbox/clients-nearby-coordinates`,
    mapboxClientsByDistrict: `${API_BASE_URL}/api/mapbox/clients-by-district`,
    clients: `${API_BASE_URL}/api/clients`,
    searchClients: `${API_BASE_URL}/api/clients/search`,
    appointments: `${API_BASE_URL}/api/appointments`,
    appointmentsFuture: `${API_BASE_URL}/api/appointments/future`,
    appointmentsPast: `${API_BASE_URL}/api/appointments/past`,
    appointmentsUnviewedCount: `${API_BASE_URL}/api/appointments/unviewed-count`,
    appointmentsSquareStatus: `${API_BASE_URL}/api/appointments/square-status`,
    statsOverview: `${API_BASE_URL}/api/stats/overview`,
    assistantChat: `${API_BASE_URL}/api/assistant/chat`,
    assistantExecute: `${API_BASE_URL}/api/assistant/execute`,
    assistantJobs: `${API_BASE_URL}/api/assistant/jobs`,
    pushPublicKey: `${API_BASE_URL}/api/push/public-key`,
    pushSubscribe: `${API_BASE_URL}/api/push/subscribe`,
    pushUnsubscribe: `${API_BASE_URL}/api/push/unsubscribe`,
    pushTest: `${API_BASE_URL}/api/push/test`,
    optimisations: `${API_BASE_URL}/api/optimisations`,
    optimisationsCarte: `${API_BASE_URL}/api/optimisations/carte`,
    textos: `${API_BASE_URL}/api/sms`,
    textosAnalyser: `${API_BASE_URL}/api/sms/analyser`,
    textosReglages: `${API_BASE_URL}/api/sms/reglages`,
  }
};

export default API_CONFIG;

